import { FaArrowRight } from "react-icons/fa";
import "./Projects.css";

import project3 from "../../img/projects/manisocail.png";
import mbcoffeetime from "../../img/projects/coffeeTime.png";
import biteamrit from "../../img/projects/biteamrit.png";
import seo from "../../img/projects/seo.png";


const featuredProjects = [
  {
    title: "Biteamrit – Fresh Cut Fruits & Organic Products",
    category: "Business / E-Commerce Website",
    description:
      "A modern platform delivering freshly cut fruits and organic products, built with fast performance, clean UI, and SEO-optimized structure to boost visibility and trust.",
    image: biteamrit,
    link: "https://biteamrit.in/",
  },

  {
    title: "SEO Audit Lite – Free Website SEO Analysis Tool",
    category: "SEO & Website Optimization Tool",
    description:
      "A powerful free SEO audit tool that analyzes website performance, accessibility, best practices, and SEO health with instant, actionable insights — no signup required.",
    image: seo, // showcase banner image for SEO Audit Lite
    link: "https://seo.oglitz.com/",
  },

  {
    title: "MBC Coffee Time – Café Website",
    category: "Restaurant / Café Website",
    description:
      "A modern café website showcasing menu, brand identity, and offerings with a clean UI, smooth user experience, and responsive design.",
    image: mbcoffeetime,
    link: "https://mbcoffeetime.netlify.app/",
  },
];

const Projects = () => {
  return (
    <section className="uniq-oglitz-projects">
      <div className="uniq-oglitz-projects__container">
        {/* HEADER */}
        <div className="uniq-oglitz-projects__header">
          <span className="uniq-oglitz-projects__badge">
            Featured Case Studies
          </span>

          <h2 className="uniq-oglitz-projects__title">
            Real Products Built for <span>Scale & Performance</span>
          </h2>

          <p className="uniq-oglitz-projects__subtitle">
            A glimpse into real-world projects crafted with clean architecture,
            premium UI, and long-term scalability.
          </p>
        </div>

        {/* PROJECT GRID */}
        <div className="uniq-oglitz-projects__grid">
          {featuredProjects.map((project, index) => (
            <a
              href={project.link}
              target="_blank"
              rel="noreferrer"
              className="uniq-oglitz-projects__card"
              key={index}
            >
              <div className="uniq-oglitz-projects__image">
                <img src={project.image} alt={project.title} />
              </div>

              <div className="uniq-oglitz-projects__content">
                <span className="uniq-oglitz-projects__category">
                  {project.category}
                </span>

                <h3>{project.title}</h3>

                <p>{project.description}</p>

                <span className="uniq-oglitz-projects__link">
                  View Live Project <FaArrowRight />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
